<template>
    <div class="big-text">
        <div class="percent">
            <span>{{ value }}</span
            ><span class="unit">{{ unit }}</span>
        </div>
        <div class="p-subtitle">{{ title }}</div>
        <div v-if="help" class="tooltip help">
            <span class="icon">
                <i class="fas fa-info-circle"></i>
            </span>
            <span class="tooltiptext">{{ help }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "BigTextWidget",
    props: ["value", "title", "help", "unit"]
};
</script>

<style scoped>
.big-text {
    font-size: 2em;
    text-align: center;
}
.p-subtitle {
    font-size: 0.7em;
}

.percent {
    font-size: 2em;
    line-height: 1;
    font-weight: bold;
}

.unit {
    font-size: 0.2em;
}

.help {
    font-size: 1em;
}

.tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
    visibility: hidden;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    font-size: 0.6em;

    /* Position the tooltip */
    position: absolute;
    z-index: 90;

    width: 240px;
    bottom: 100%;
    left: 50%;
    margin-left: -120px; /* Use half of the width (120/2 = 60), to center the tooltip */
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}
</style>
